// oxlint-disable-next-line eslint/no-restricted-imports
import * as oldColors from './colors';

// Only for use in contextual color definitions
export const gray50 = '#f6f8fa';
export const gray80 = '#f0f4f6';
export const gray100 = '#e8ecf0';
export const gray150 = '#d4dae0';
export const gray200 = '#bdc5cf';
export const gray300 = '#98a1ae';
export const gray400 = '#747c8b';
export const gray500 = '#4d5768';
export const gray600 = '#373b4a';
export const gray700 = '#242733';
export const gray800 = '#141520';
export const gray900 = '#080811';
export const navy50 = oldColors.n11;
export const navy100 = oldColors.n10;
export const navy150 = oldColors.n9;
export const navy200 = oldColors.n8;
export const navy300 = oldColors.n7;
export const navy400 = oldColors.n6;
export const navy500 = oldColors.n5;
export const navy600 = oldColors.n4;
export const navy700 = oldColors.n3;
export const navy800 = oldColors.n2;
export const navy900 = oldColors.n1;
export const blue50 = oldColors.b11;
export const blue100 = oldColors.b10;
export const blue150 = oldColors.b9;
export const blue200 = oldColors.b8;
export const blue300 = oldColors.b7;
export const blue400 = oldColors.b6;
export const blue500 = oldColors.b5;
export const blue600 = oldColors.b4;
export const blue700 = oldColors.b3;
export const blue800 = oldColors.b2;
export const blue900 = oldColors.b1;
export const green50 = oldColors.g11;
export const green100 = oldColors.g10;
export const green150 = oldColors.g9;
export const green200 = oldColors.g8;
export const green300 = oldColors.g7;
export const green400 = oldColors.g6;
export const green500 = oldColors.g5;
export const green600 = oldColors.g4;
export const green700 = oldColors.g3;
export const green800 = oldColors.g2;
export const green900 = oldColors.g1;
export const orange50 = oldColors.y11;
export const orange100 = oldColors.y10;
export const orange150 = oldColors.y9;
export const orange200 = oldColors.y8;
export const orange300 = oldColors.y7;
export const orange400 = oldColors.y6;
export const orange500 = oldColors.y5;
export const orange600 = oldColors.y4;
export const orange700 = oldColors.y3;
export const orange800 = oldColors.y2;
export const orange900 = oldColors.y1;
export const red50 = oldColors.r11;
export const red100 = oldColors.r10;
export const red150 = oldColors.r9;
export const red200 = oldColors.r8;
export const red300 = oldColors.r7;
export const red400 = oldColors.r6;
export const red500 = oldColors.r5;
export const red600 = oldColors.r4;
export const red700 = oldColors.r3;
export const red800 = oldColors.r2;
export const red900 = oldColors.r1;
export const purple50 = oldColors.p11;
export const purple100 = oldColors.p10;
export const purple150 = oldColors.p9;
export const purple200 = oldColors.p8;
export const purple300 = oldColors.p7;
export const purple400 = oldColors.p6;
export const purple500 = oldColors.p5;
export const purple600 = oldColors.p4;
export const purple700 = oldColors.p3;
export const purple800 = oldColors.p2;
export const purple900 = oldColors.p1;
export const white = '#ffffff';
export const black = '#000000';
export const hover = oldColors.hover;
